import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  Form, FormGroup, Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup,
  Collapse, Button, Fade, Jumbotron,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText
} from 'reactstrap';

import { makeInput } from "common-import/custom";
import { inject, observer } from "mobx-react";

@inject("userStore") @observer
class ImportUsers extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      type: "1"
    };

    this.readingExcel = this.readingExcel.bind(this)
  }

  readingExcel(e) {
    console.log(e)
  }

  render() {

    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> Create one user (Đã chạy)
              </CardHeader>
              <CardBody>
                <Form action="" method="post" onSubmit={this.submitCreateOneUser}>
                  <FormGroup>
                    <Label htmlFor="nf-email">Email:</Label>
                    {makeInput(this, "email")(<Input type="text" value="12" />)}
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">First name:</Label>
                    {makeInput(this, "firstName")(<Input type="text" />)}
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">Last name:</Label>
                    {makeInput(this, "lastName")(<Input type="text" />)}
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="nf-email">Password:</Label>
                    {makeInput(this, "password")(<Input type="password" />)}
                  </FormGroup>
                  <FormGroup row>
                    <Col md="3">
                      <Label htmlFor="multiple-select">Account Type:</Label>
                    </Col>
                    <Col md="9">
                      {makeInput(this, "type")(<Input type="select" name="multiple-select" id="multiple-select" >
                        <option value="1">Project Owner</option>
                        <option value="2">Contractor</option>
                        <option value="3">Supplier</option>
                      </Input>)}
                    </Col>
                  </FormGroup>
                </Form>
              </CardBody>
              <CardFooter>
                <Button type="submit" size="sm" color="primary" onClick={this.submitCreateOneUser}><i className="fa fa-dot-circle-o"></i> Save</Button>
                <Button type="reset" size="sm" color="danger" onClick={() => this.resetFormState()}><i className="fa fa-ban"></i> Cancel</Button>
              </CardFooter>
            </Card>
          </Col>
          <Col xs="12" md="6">
            <Card>
              <CardHeader>
                <i className="fa fa-envelope-open"></i> Create multiple users - Upload files (Chưa chạy)
              </CardHeader>
              <CardBody>
                <Form action="" method="post" className="form-horizontal">
                  <FormGroup row>
                    <Col md="12">
                      <InputGroup>
                        <InputGroupAddon addonType="prepend" className="group-file-upload">
                          <Input onChange={this.readingExcel} name="uploadFile" id="uploadFile" type="file" />
                          <Label htmlFor="uploadFile" className="btn btn-primary">
                            <i className="fa fa-file"></i> Upload
                          </Label>
                        </InputGroupAddon>
                        <Input type="text" id="input1-group2" name="input1-group2" placeholder="File path .xlsx .csv" />
                      </InputGroup>
                    </Col>
                  </FormGroup>
                </Form>
                <CardFooter>
                  <Button type="submit" size="sm" color="success"><i className="fa fa-dot-circle-o"></i> Submit</Button>
                  <Button type="reset" size="sm" color="danger"><i className="fa fa-ban"></i> Reset</Button>
                </CardFooter>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>
    );
  }

  submitCreateOneUser = async e => {
    e => e.preventDefault();
    const { userStore } = this.props;
    const { email, firstName, lastName, password, type } = this.state;
    let userType;
    switch(type) {
      case "1": userType = ["ProjectOwner"]; break;
      case "2": userType = ["Contractor"]; break;
      case "3": userType = ["Supplier"]; break;
    }
    let registerResult = await userStore.register({ email, firstName, lastName, password, type: userType });
    if(!!registerResult.error) window.toast.error("Có lỗi xảy ra, vui lòng thử lại   "+ JSON.stringify(registerResult.error));
    else {
      window.toast.success("Thêm user mới thành công");
      this.resetFormState();
    }
    
  }

  resetFormState = () => {
    this.setState({ email:"", firstName: "", lastName: "", type: "1", password: "" })
  }
}

export default ImportUsers;


// WEBPACK FOOTER //
// ./src/views/Users/ImportUsers.js